import React from "react";
import { Button as StyledButton, ButtonStyleProps } from "./OldButton-styles";

interface PropTypes extends ButtonStyleProps {
  children: React.ReactNode;
  onPress?: () => void;
}

function Button(props: PropTypes) {
  let { children, onPress, ...styleProps } = props;

  return (
    <StyledButton onPress={onPress} {...styleProps}>
      {props.children}
    </StyledButton>
  );
}

export default Button;
